export type TBadgeColor =
  | 'error'
  | 'success'
  | 'primary'
  | 'secondary'
  | 'gray'
  | 'warning'
  | 'sky'
  | 'violet'
  | 'flamingo'

export enum EUserStatus {
  INCOMPLETE = 'INCOMPLETE',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export enum EStepStatus {
  PENDING = 'PENDING',
  NEEDS_REVISION = 'NEEDS_REVISION'
}
